module.exports = __webpack_public_path__ + "static/img/cityImg.b02875d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/cityImg.webp
// module id = hVeI
// module chunks = 1